const EMPTY = Symbol('EMPTY')
const READY_TO_LOAD_MORE = Symbol('READY_TO_LOAD_MORE')

export const loadMoreSectionsStatus = {
  EMPTY,
  READY_TO_LOAD_MORE,
}

export default loadMoreSectionsStatus
